import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ThankYou } from './pages/ThankYou';
import { landingVariants } from './data/landingVariants';
const [bayArea, northernCalifornia, outOfState] = landingVariants;
const knownPaths = ['/bay-area', '/northern-california', '/out-of-state', '/thank-you'];
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="2rlf8ayeo3y5h">
      <FallbackRedirect data-id="element-1" data-mp="2rit2b37fdqpd" />
      <Routes data-id="element-2" data-mp="2mlu68f47b9oj">
        <Route path="/bay-area" element={<LandingPage variant={bayArea} data-id="element-4" data-mp="2mn5f2tci77mi" />} data-id="element-3" data-mp="2mmcbu2cr7094" />
        <Route path="/northern-california" element={<LandingPage variant={northernCalifornia} data-id="element-6" data-mp="31brz38d2snk2" />} data-id="element-5" data-mp="31aqfgfhzusqq" />
        <Route path="/out-of-state" element={<LandingPage variant={outOfState} data-id="element-8" data-mp="2wiyxgtcwlvc7" />} data-id="element-7" data-mp="2wk0ah3dhcrwk" />
        <Route path="/thank-you" element={<ThankYou data-id="element-10" data-mp="28tw44o8wqe1v" />} data-id="element-9" data-mp="2wi5nzkmk8rqd" />
      </Routes>
    </BrowserRouter>;
}

// Sends the domain root (and any unknown address) to the Bay Area page
// without registering an extra route.
function FallbackRedirect() {
  const {
    pathname
  } = useLocation();
  const normalized = pathname.replace(/\/+$/, '') || '/';
  if (knownPaths.includes(normalized)) return null;
  return <Navigate to="/bay-area" replace data-id="element-11" data-mp="3mjgannkimdn9" />;
}